import { Alert, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";

export default function ShowMessage(props) {
    const [snackbar, setSnackbar] = useState(props.snackbar ?? true);
    const [message, setMessage] = useState(props.message ?? "");
    const [keepfor, setKeepFor] = useState(props.keepfor ?? null);
    const [severity, setSeverity] = useState(props.severity ?? "");

    useEffect(() => {
        setSnackbar(props.snackbar ?? true);
        setMessage(props.message ?? "");
        setKeepFor(props.keepfor ?? null);
        setSeverity(props.severity ?? "")
    }, [props]);

    if (message !== null && message !== "") {
        if (snackbar) {
            return <Snackbar
                open={message !== null && message !== ""}
                autoHideDuration={keepfor}
                onClose={(event, reason) => {
                    if (reason === 'clickaway') {
                        return;
                    }
                    setMessage(null);
                }}>
                <Alert variant="filled"
                    sx={{ width: '100%' }} onClose={(event, reason) => {
                        if (reason === 'clickaway') {
                            return;
                        }
                        setMessage(null);
                    }} severity={severity}>{message}</Alert>
            </Snackbar>;
        } else {
            return <Alert variant="filled"
                sx={{ width: '50%' }} onClose={(event, reason) => {
                    if (reason === 'clickaway') {
                        return;
                    }
                    setMessage(null);
                }} severity={severity}>{message}</Alert>;
        }
    } else
        return null;
}